import { AppButton, AppCard, AppInputGroup, AppLabel, AppModal } from "@dcam/dcam_flhealth_component_library";
import React, { useEffect, useState } from "react";
import {
  Accordion,
  Card,
  Container,
  Row,
  Col,
  Form,
  Modal,
  // etc...
} from "react-bootstrap";
import useGetData from "../../hooks/useGetData";
import { FormProvider, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import usePost from "../../hooks/usePost";
import { RoleData } from "../Dashboard/Dashboard.types";
import { CreateUserFormValidationSchema, UserDataFormRequest } from "../UserManagement/CreateUser.types";
import { yupResolver } from "@hookform/resolvers/yup";
import { ApiResponse } from "../Dashboard/ApiResponse";
import { NavLink, useNavigate } from "react-router-dom";
import { FacilityRegistrationValidationSchema } from "./FacilityRegistration.types";
import formatPhoneNumber from "../../helpers/formatPhoneNumber";
import { useParams, useSearchParams } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { fal, faMemoCircleCheck, faPen, faTrash } from "@fortawesome/pro-light-svg-icons";
import AppDataTable from "../../component/AppDataTable/AppDataTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LocationModal from "./LocationModal";
import "./FacilityEdit.scss";
import UserDashboard from "../UserManagement/UserDashboard";
import UserModal from "./UserModal";
import CreateUser from "../UserManagement/CreateUser";
import { uploadFile } from "../../hooks/uploadFile";



interface DropdownItem {
  value: string;
  text: string;
}

interface SelectOption {
  id: string;
  value: string;
}

export interface HospitalRegistrationRequest {
  userEmail: string;
  hospitalName: string;
  hospitalTypeId: number;
  hospitalAddress: string;
  hospitalCity: string;
  hospitalZipCode: string;
  stateId: number;
  countyId: number;
  userFirstName: string;
  userLastName: string;
  userPhoneNumber: string;
  roleId?: number | null;
  isApproved?: boolean | null;
  createdBy?: string | null;
  dateCreated?: string | null;
}


const FacilityEdit: React.FC = () => {
  const { hospitalId, hospitaltype } = useParams(); // Path parameter

  const { instance, accounts } = useMsal();

  const account = accounts[0];
  const loggedInUser = accounts[0] && accounts[0].username;

  const { Id, type } = useParams(); // Path parameter
  const navigate = useNavigate();
  const methods = useForm<HospitalRegistrationRequest>({
    resolver: yupResolver(FacilityRegistrationValidationSchema)
  });

  const {
    handleSubmit,
    getValues,
    trigger,
    setValue,
    formState: { errors },
  } = methods;

  const [states, setStates] = useState<SelectOption[]>([]);
  const [counties, setCounties] = useState<SelectOption[]>([]);
  const [allRolesData, setAllRolesData] = useState<SelectOption[]>([]);
  const [allFacilitiesData, setAllFacilitiesData] = useState<SelectOption[]>([]);
  const [emailError, setEmailError] = useState("");
  const [emailErrorColor, setEmailErrorColor] = useState("");
  const [fieldsEnabled, setFieldsEnabled] = useState(false);
  const [isModalShow, setModalShow] = useState(false);
  const [isUserModalShow, setUserModalShow] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [selectedUserRow, setUserSelectedRow] = useState<any>(null);
  const [allRoutinizedHospitalsData, setallRoutinizedHospitalsData] = useState<SelectOption[]>([]);
  //const [filteredRoutinizedFacilities, setFilteredRoutinizedFacilities] =useState<SelectOption[]>([]);
  const [selectedHospitalId, setSelectedHospitalId] = useState<number | null>(null);
  const [isHospitalSubmitting, setIsHospitalSubmitting] = useState(false);
  const [hospitalTypes, setHopitalTypes] = useState<SelectOption[]>([]);

  const initialHospitalData = {
    hospitalTypeId: 0,
    hospitalName: "",
    hospitalAddress: "",
    hospitalCity: "",
    stateId: 0,
    countyId: "",
    hospitalZipCode: "",
    //FacilityPhone: "",
    userFirstName: "",
    userLastName: "",
    userPhoneNumber: "",
    roleId: "",
    userEmail: ""
  };
  const [hospitalData, setHospitalData] = useState(initialHospitalData);
  const [stateIdData, setStateId] = useState(0);
  const [hospitalCityData, sethospitalCity] = useState("");
  const [userEmailData, setuserEmail] = useState("");
  const [submitStatus, setSubmitStatus] = useState(true);
  const [setFacilities, setFacilitiesData] = useState([]);
  const [userData, setUserData] = useState<any>();
  

  const { getDataById: getStates } = useGetData<SelectOption[], string>(
    "Client/States",
    "GET"
  );

  const { getDataById: getHospitalTypes } = useGetData<SelectOption[], string>(
    "Client/GetHospitalTypes",
    "GET"
  );

  const { getDataById: getCounties } = useGetData<SelectOption[], string>(
    "Client/Counties",
    "GET"
  );

  // const { getDataById: getRoles } = useGetData<RoleData[], string>(
  //   "Client/RoutinizedFacilities",
  //   "GET"
  // );

   const { getDataById: getFilesByUserId } = useGetData<any[], number>(
      `FileUpload/GetByUserId`,
      "GET"
    );
  
  const { postByObject: postUser } = usePost<number, UserDataFormRequest>(
    "UserSecurity/Update",
    "POST"
  );

  const { getDataById: checkEmailExist } = useGetData(
    `UserSecurity/CheckUserByEmail`,
    "GET"
  );
  const mapToSelectOptions = (data: RoleData[]): SelectOption[] => {
    return data.map((item) => ({
      id: item?.id?.toString(),
      value: item?.value,
    }));
  };

  const { getDataById: getRoutinizedHospitals } = useGetData<
    SelectOption[],
    string
  >("Client/RoutinizedHospitals", "GET");



  const { getDataById: getAllRoutinizedFacilities } = useGetData<
    any,
    string
  >("Client/GetAllRoutinizedFacilities", "GET");

  const { getDataById: getRoutinizedHospitalsById } = useGetData<
    any,
    string
  >("Client/RoutinizedHospitals", "GET");

  //let caseReportSelectedRoutinizedFacility = "2";
  const handleRoutinizedHospitalChange = async (e: any) => {
    const selectedHospital = e.target.value;
    setCaseReportSelectedRoutinizedHospital(e.target.value);


    setCaseReportSelectedRoutinizedFacility("");
    if (selectedHospital == "0") {
      setFilteredRoutinizedFacilities([]);
    } else {
      try {
        const facilityData = await getAllRoutinizedFacilities(
          `${selectedHospital}`
        );

        if (facilityData) {
          const mappedFacilities = mapToSelectOptions(facilityData);
          setFilteredRoutinizedFacilities([
            { id: "0", value: "----- Select Routinized Facilities -----" },
            ...mappedFacilities,
          ]);
        }
      } catch (error) {
        setFilteredRoutinizedFacilities([]);
      }
    }
  };
  
   const [caseReportSelectedRoutinizedHospital, setCaseReportSelectedRoutinizedHospital] = useState<string>("");
  const [caseReportSelectedRoutinizedFacility, setCaseReportSelectedRoutinizedFacility] = useState<string>("");
  const [filteredRoutinizedFacilities, setFilteredRoutinizedFacilities] = useState<SelectOption[]>([]);
  useEffect(() => {
    const initializeFacilities = async () => {
      //const defaultHospital = "2";
      setCaseReportSelectedRoutinizedHospital("");
      setCaseReportSelectedRoutinizedFacility("");

      if (hospitalId === "0") {
        const facilityData = await getAllRoutinizedFacilities(`${hospitalId}`);
        if (facilityData) {
          setFacilitiesData(facilityData);

          const mappedFacilities = mapToSelectOptions(facilityData);
          setFilteredRoutinizedFacilities([
            { id: "0", value: "----- Select Routinized Facilities -----" },
            ...mappedFacilities,
          ]);
        }
      } else {
        try {
          const facilityData = await getAllRoutinizedFacilities(`${hospitalId}`);
          if (facilityData) {
            setFacilitiesData(facilityData);
            const mappedFacilities = mapToSelectOptions(facilityData);
            setFilteredRoutinizedFacilities([
              { id: "0", value: "----- Select Routinized Facilities -----" },
              ...mappedFacilities,
            ]);
          }
        } catch (error) {
          setFilteredRoutinizedFacilities([]);
        }
      }

    };

    initializeFacilities();
    const initializeHospitals = async () => {
      const facilityData = await getRoutinizedHospitalsById(`${hospitalId}`);
      if (facilityData) {
        setValue("hospitalName", facilityData?.routinizedHospitalName);
        setValue("hospitalZipCode", facilityData?.zipCode);
        setValue("hospitalCity", facilityData?.city);
        setValue("hospitalAddress", facilityData?.address)
        setValue("hospitalTypeId", facilityData?.hospitalTypeId)
        setValue("countyId", facilityData?.countyId)
        setHospitalData(facilityData);

      }
      if (hospitaltype == "Edit") {
        setFieldsEnabled(true);
      }
    };
    initializeHospitals();

    const loadData = async () => {
      const data = await getAllUserSecurity("");
      if(data){
      
                let filterData=data?.filter((x: { routinizedHospitalId: any; })=>x.routinizedHospitalId==hospitalId);
                setUserData(filterData);      
      }
    };
    loadData();    


  }, []);

  const handleRoutinizedFacilityChange = (e: any) => {
    setCaseReportSelectedRoutinizedFacility(e.target.value);
    const selectedOption = e.target.options[e.target.selectedIndex];
    const dataValue = selectedOption.getAttribute("data-value");

    if (e.target.value === "Other" || dataValue === "Other") {
      // Enable Other Facility Textbox
      // setCaseReportOtherFacilityDetailIsDisabled(false);
    } else {
      // setCaseReportOtherFacilityDetailIsDisabled(true);
      // setCaseReportSetOtherFacilityDetail("");
    }
  };



  const { getDataById: getAllUserSecurity } = useGetData<any, string>(
    "UserSecurity/GetAllUserSecurity",
    "GET"
  );

  const { postByObject: postHospitalRegistration } = usePost<
    ApiResponse,
    HospitalRegistrationRequest
  >("HospitalRegistration/AddHospital", "POST");
  


  const { postByObject: ApproveRejectHospitalRegistration } = usePost<
    ApiResponse,
    any
  >("HospitalRegistration/StatusUpdateHospitalRegistration", "POST");

  const { postByObject: RoutinizedFacilityPost } = usePost<
    ApiResponse,
    any
  >("Client/RoutinizedFacilities", "POST");

  const { getDataById: RoutinizedFacilityDelete } = useGetData<any, string>(
    "Client/RoutinizedFacilities",
    "DELETE"
  );

  const { getDataById: getFacilityById } = useGetData<any, string>(
    "HospitalRegistration/GetHospitalRegistrationsById",
    "GET"
  );
  


  useEffect(() => {
    setValue("stateId", 10)
    // Fetch states and counties using your API hooks or client
    const fetchStatesAndCounties = async () => {
      const stateData = await getStates(""); // Replace with actual API call
      const countyData = await getCounties(""); // Replace with actual API call
      setStates(stateData || []);
      setCounties(countyData || []);
    };

    fetchStatesAndCounties();

    const fetchHospitalTypes = async () => {
      let data = await getHospitalTypes(""); // Fetch hospital types
      if (data) {
        const mappedData = data.map((item) => ({
          id: item.id.toString(),
          value: item.value,
        }));

        // Add "Select Hospital Type" as the first option
        setHopitalTypes(mappedData);
      }
    };

    fetchHospitalTypes();

    // const fetchRoles = async () => {
    //     const roleData = await getRoles("");
    //     if (roleData) {
    //       const mappedRoles = roleData.map((item: { id: { toString: () => any; }; value: any; }) => ({
    //         id: item.id.toString(),
    //         value: item.value,
    //       }));

    //       setAllRolesData([
    //         ...mappedRoles,
    //       ]);
    //   }
    // };

    // fetchRoles();


  }, []);









  const onSubmit = async (formData: any) => {
    

    setIsHospitalSubmitting(true);

    // 1. Confirm user action
    if (!type || type == "Edit") {
      const userConfirmed = window.confirm(
        "Please confirm if you would like to save the hospital data?"
      );
      if (!userConfirmed) {
        setIsHospitalSubmitting(false);
        return;
      }
      formData.hospitalRegistrationId = Id;
      // 2. Build the final request from the validated `formData`
      const hospitalRequest: HospitalRegistrationRequest = {
        ...formData,                 // Spread the validated data
        roleId: 2,                   // override or set as needed
        isApproved: null,            // override
        createdBy: "Admin",          // override
        dateCreated: new Date().toISOString(),
        updatedBy: "",
      };

      try {
        await postHospitalRegistration(hospitalRequest);

        // 3. Show success toast
        toast.success("Hospital data saved successfully!", {
          position: "top-right",
          autoClose: 2000,
        });

        // 4. Redirect or clear

        if (type == "Edit") {
          navigate('/Facility/Review');
        }
        else {
          navigate(`/success?email=${encodeURIComponent(formData.userEmail)}`);
        }
      } catch (error) {
        console.error("Error saving hospital data:", error);
        toast.error("An error occurred while saving hospital data.", {
          position: "top-right",
          autoClose: 2000,
        });
      } finally {
        setIsHospitalSubmitting(false);
      }
    }


  };

  const handleReject = () => {
    console.log("Rejected");
    // Add your reject logic here
  };

  const handleApprove = async () => {
    setSubmitStatus(false);
    const hospitalRequest: any = {
      roleId: 2,                   // override or set as needed
      isApproved: true,            // override
      createdBy: "Admin",          // override
      dateCreated: new Date().toISOString(),
      hospitalRegistrationId: Number(Id),
      hospitalName: "",
      updatedBy: loggedInUser
    };

    try {
      await ApproveRejectHospitalRegistration(hospitalRequest);

      // 3. Show success toast
      toast.success("Hospital data approved successfully!", {
        position: "top-right",
        autoClose: 2000,
      });

      // 4. Redirect or clear
      navigate('/Facility/Review');
    } catch (error) {
      console.error("Error saving hospital data:", error);
      toast.error("An error occurred while saving hospital data.", {
        position: "top-right",
        autoClose: 2000,
      });
    } finally {
      setIsHospitalSubmitting(false);
    }

  };

  const handleDelete = async (row:any) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this Location?");
  
    if (!isConfirmed) {
      return; // Exit if the user cancels
    }

    try {
      await RoutinizedFacilityDelete(`${row?.routinizedFacilityId}/Delete/true`);

      // 3. Show success toast
      toast.success("Location deleted successfully!", {
        position: "top-right",
        autoClose: 2000,
      });
      const facilityData = await getAllRoutinizedFacilities(`${hospitalId}`);
      if (facilityData) {
        setFacilitiesData(facilityData);
      }
      // 4. Redirect or clear
      
    } catch (error) {
      console.error("Error saving hospital data:", error);
      toast.error("An error occurred while saving hospital data.", {
        position: "top-right",
        autoClose: 2000,
      });
    } finally {
      setIsHospitalSubmitting(false);
    }

  };


  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
  const [rejectComment, setRejectComment] = useState("");

  const handleRejectClick = () => {
    setIsRejectModalOpen(true);
  };

  const handleModalClose = () => {
    setIsRejectModalOpen(false);
    setRejectComment("");
  };

  const handleRejectSubmit = async () => {

    setIsRejectModalOpen(false);
    setSubmitStatus(false);
    const hospitalRequest: any = {
      roleId: 2,                   // override or set as needed
      isApproved: false,            // override
      createdBy: "Admin",          // override
      dateCreated: new Date().toISOString(),
      hospitalRegistrationId: Number(Id),
      hospitalName: "",
      updatedBy: loggedInUser,
      note: rejectComment
    };

    try {
      await ApproveRejectHospitalRegistration(hospitalRequest);

      // 3. Show success toast
      toast.success("Hospital data approved successfully!", {
        position: "top-right",
        autoClose: 2000,
      });

      // 4. Redirect or clear
      navigate('/Facility/Review');
    } catch (error) {
      console.error("Error saving hospital data:", error);
      toast.error("An error occurred while saving hospital data.", {
        position: "top-right",
        autoClose: 2000,
      });
    } finally {
      setIsHospitalSubmitting(false);
    }
  };

  const LocationTableColumn = [
    {
      name: <b>Location ID</b>,  //RoutinizedFacilityId
      selector: (row: any) => row.routinizedFacilityId,
      width: "160px",
    },
    {
      name: <b>Location Name</b>,
      selector: (row: any) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                {row.routinizedFacilityName}
                              </div>,
      width: "330px",
    },
    {
      name: <b>Address</b>,
      selector: (row: any) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                {row.address+ ", " + row.city}
                              </div>,
      width: "300px",
    },
    {
      name: <b>Status</b>,
      selector: (row: any) => row.isActive? "Active":"InActive",
      width: "100px",
    },
    {
      name: <b style={{ display: "block", textAlign: "center", width: "100%" }}>Action</b>,
      selector: (row: any) => (
        <div>
          <AppButton
            variant={"secondary"}
            onClick={() => {
              setModalShow(true);
              setSelectedRow(row);
            }}
            disabled={!fieldsEnabled}
          >
            <FontAwesomeIcon icon={faPen} /> &nbsp;
            Edit
          </AppButton> &nbsp;
          <AppButton
            variant={"secondary"}
          onClick={(e) => {
            handleDelete(row)
              
          }}
          disabled={!fieldsEnabled}
          >
            <FontAwesomeIcon icon={faTrash} /> &nbsp;
            Delete
          </AppButton>

        </div>
      ),
      width: "250px",
    },

  ]

  const handleModalSubmit = async (data: any) => {
    // Construct the hospitalRequest object using the data from the modal
    const hospitalRequest = {
        hospitalTypeId: hospitalData.hospitalTypeId,
        routinizedFacilityName: data.routinizedFacilityName || "",
        address: data.address || "",
        city: data.city || "",
        countyId: data.countyId || "",
        stateId: data.stateId || "",
        zipCode: data.zipCode || "",
        createdBy: loggedInUser,
        updatedBy: selectedRow?loggedInUser:"",
        dateCreated: new Date().toISOString(),
        routinizedHospitalId: Number(hospitalId),
        routinizedFacilityId:selectedRow?selectedRow?.routinizedFacilityId:undefined,
        isActive: data.isActive,
        hospitalRegistrationId: selectedRow?selectedRow?.hospitalRegistrationId:null,
    };

    try {
        await RoutinizedFacilityPost(hospitalRequest); // API call
        const facilityData = await getAllRoutinizedFacilities(`${hospitalId}`);
        if (facilityData) {
          setFacilitiesData(facilityData);
        }
        setModalShow(false); // Close the modal on success
    } catch (error) {
        console.error("Failed to save data:", error);
    }
};

const handleFileUpload = async (file: File, userId: number) => {
    // Allowed file extensions
    const allowedExtensions = [".pdf", ".jpg", ".png", ".docx",".gif"];
    const fileExtension = file.name.slice(file.name.lastIndexOf(".")).toLowerCase();
  
    if (!allowedExtensions.includes(fileExtension)) {
      console.error(`Invalid file type: ${fileExtension}`);
      throw new Error(`File type not allowed. Allowed types: ${allowedExtensions.join(", ")}`);
    }
  
    const token = sessionStorage.getItem("accessToken");
    const fileUpload = {
      fileName: file.name, 
      documentName: file.name, 
      filePath: "", 
      createdBy: "Admin",
    };
  
    try {
      const response = await uploadFile(file, userId, fileUpload, token);
      console.log("File uploaded successfully:", response);
      return response;
    } catch (error: any) {
      console.error("File upload failed:", error.message || error);
  
      // Throw the error to be caught in the calling function
      throw new Error(error.message || "File upload failed.");
    }
  };

const handleCreateUserSubmit = async (data:any) => {
    const userFormData = methods.getValues();
  
    // Validate if both files are uploaded
    if(!selectedUserRow){
        if (!data.userDataAgreementFile || !data.ssnPolicyFile) {
          toast.error("Please upload both required files before submitting.", {
            position: "top-right",
            autoClose: 2000,
          });
          return;
        }
      }
    const userConfirmed = window.confirm(
      "Please confirm if you would like to save?"
    );
    if (!userConfirmed) {
      return;
    }
  
    try {
     
  data.createdBy=loggedInUser;
  if(selectedUserRow){
    data.userId=selectedUserRow.userId;
  }
  if(!selectedUserRow){
  // Step 1: Validate and upload files before creating the user
      const fileValidationAndUpload = async (file: File, userId: number) => {
        // Ensure the file exists before processing
        if (!file) {
          throw new Error("File not provided.");
        }
  
        try {
          return await handleFileUpload(file, userId);
        } catch (error) {
          if (error instanceof Error) {
            throw new Error(`${file.name}: ${error.message}`);
          } else {
            throw new Error(` ${file.name}: Unknown error.`);
          }
        }
      };
  
      // Temporary userId to validate files first
      const temporaryUserId = -1;
  
      // Validate and upload files
      await fileValidationAndUpload(data.userDataAgreementFile, temporaryUserId);
      await fileValidationAndUpload(data.ssnPolicyFile, temporaryUserId);
    }
      // Step 2: Create the user after successful file uploads
      const saveResponse = await postUser(data);
      const userId = saveResponse;
  
      if (!userId || typeof userId !== "number") {
        throw new Error("Failed to create user. No valid userId returned.");
      }
if(!selectedUserRow){
      // Step 3: Re-associate uploaded files with the created user
      const associateFilesWithUser = async (file: File) => {
        try {
          await handleFileUpload(file, userId);
        } catch (error) {
          if (error instanceof Error) {
            console.error(`Failed to associate file ${file.name} with user: ${error.message}`);
          } else {
            console.error(`Failed to associate file ${file.name} with user: Unknown error.`);
          }
        }
      };
  
      await associateFilesWithUser(data.userDataAgreementFile);
      await associateFilesWithUser(data.ssnPolicyFile);
    }
      toast.success("Data saved successfully!", {
        position: "top-right",
        autoClose: 2000,
      });
  
      if(saveResponse){
        const data = await getAllUserSecurity("");
        if(data){
        
                  let filterData=data?.filter((x: { routinizedHospitalId: any; })=>x.routinizedHospitalId==hospitalId);
                  setUserData(filterData); 
        }
      }
    } catch (error) {
  
      if (error instanceof Error) {
        toast.error(`${error.message}`, {
          position: "top-right",
          autoClose: 15000,
        });
      } else {
        toast.error("An unexpected error occurred.", {
          position: "top-right",
          autoClose: 3000,
        });
      }
      console.error("Error occurred:", error);
    }
  };

  const handleUserEditClick = async (row:any) => {
    const userId = row.userId;
    try {
      const userFiles = await getFilesByUserId(userId); // Replace with actual API call
      setUserSelectedRow({...row,files: userFiles});
      setUserModalShow(true);
    } catch (error) {
      setUserSelectedRow(row);
      setUserModalShow(true);
    }
    
    

  };
  

  const UserColumn = [
        {
            name: <b>First Name</b>,
            selector: (row: any) => row.firstName,
        },
        {
            name: <b>Last Name</b>,
            selector: (row: any) => row.lastName,
        },
        {
            name: <b>Email</b>,
            selector: (row: any) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                {row.email}
                </div>,
            width: "280px",
        },
        {
            name: <b>Role</b>,
            selector: (row: any) => row.roleName,
            width: "100px",
        },
        {
            name: <b>Hospital/Location</b>,
            selector: (row: any) => 
                <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                    {row.routinizedHospitalName?
                    <div>
                    {row.routinizedHospitalName? `${row.routinizedHospitalName}`:"-"}
                    <br></br>
                    {row.routinizedHospitalName? <>&emsp;&emsp;- {row.routinizedFacilityName}</>:""}
                    </div>
                    : "-"}

                </div>,
            sortable: true,
            width: "250px",
        },
        {
            name: <b>Status</b>,
            selector: (row: any) => row.isActive?"Active":"Inactive",
            width: "100px",
        },
        
       
        {
            name: <b style={{ display: "block", marginLeft: "20px", width: "100%" }}>Action</b>,
            selector: (row: any) => 
                <div>
                    <AppButton
                        variant={"secondary"}
                        onClick={() =>handleUserEditClick(row)}
                        disabled={!fieldsEnabled}
                      >
                        <FontAwesomeIcon icon={faPen}/> &nbsp;
                        Edit
                    </AppButton>
                </div>,
            //width: "100px",
        },
    ];

  return (
    <>
      <Container>
        {/* Facility Information Card */}
        <FormProvider {...methods}>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <AppCard>
              <AppCard title="Facility Edit" bottomMargin>

                <Row className="mb-4">
                  <Col>
                    <AppLabel label="Facility Type" required />
                    <Form.Select {...methods.register("hospitalTypeId", { valueAsNumber: true })} 
                      value={
                        hospitalTypes.find(
                          (ht) => Number(ht.id) == hospitalData.hospitalTypeId)?.id || ""
                      }
                      onChange={(e) =>
                        setHospitalData({
                          ...hospitalData,
                          hospitalTypeId: Number(e.target.value),
                        })
                      }
                    disabled
                    >
                      <option value="0">Select Hospital Type</option>
                      {hospitalTypes.map((option) => (
                        <option key={option.id} value={Number(option.id)}>
                          {option.value}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.hospitalTypeId && (
                      <p className="text-danger mb-0">
                        {errors.hospitalTypeId.message}
                      </p>
                    )}
                  </Col>
                  <Col>
                    <AppLabel label="Facility Name" required />
                    <Form.Control
                      type="text"
                      {...methods.register("hospitalName")}
                      value={hospitalData.hospitalName}
                      onChange={(e) =>
                        setHospitalData({
                          ...hospitalData,
                          hospitalName: e.target.value,
                        })
                      }
                      disabled
                    />
                    {errors.hospitalName && (
                      <p className="text-danger mb-0">
                        {errors.hospitalName.message}
                      </p>
                    )}
                  </Col>
                  <Col>
                    <AppLabel label="Facility Address" required />
                    <Form.Control
                      type="text"
                      {...methods.register("hospitalAddress")}
                      value={hospitalData.hospitalAddress}
                      onChange={(e) =>
                        setHospitalData({
                          ...hospitalData,
                          hospitalAddress: e.target.value,
                        })
                      }
                      disabled
                    />
                    {errors.hospitalAddress && (
                      <p className="text-danger mb-0">
                        {errors.hospitalAddress.message}
                      </p>
                    )}
                  </Col>
                </Row>

                <Row className="mb-4">
                  <Col>
                    <AppLabel label="City" required />
                    <Form.Control
                      type="text"
                      {...methods.register("hospitalCity")}  // This now controls 'city' entirely
                      disabled
                    />
                    {errors.hospitalCity && (
                      <p className="text-danger mb-0">
                        {errors.hospitalCity.message}
                      </p>
                    )}
                  </Col>
                  <Col>
                    <AppLabel label="State" required />
                    <Form.Select
                      value={10}  // Florida=10
                      {...methods.register("stateId", { valueAsNumber: true })}
                      disabled //={!fieldsEnabled}
                    >
                      <option value={0}>Choose State...</option>
                      {states.map((st) => (
                        <option key={st.id} value={Number(st.id)}>
                          {st.value}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.stateId && (
                      <p className="text-danger mb-0">
                        {errors.stateId.message}
                      </p>
                    )}
                  </Col>
                  <Col>
                    <AppLabel label="County" required />
                    <Form.Select
                      {...methods.register("countyId", { valueAsNumber: true })}
                      value={counties.find((ct) => Number(ct.id) == Number(hospitalData.countyId))?.id || ""}
                      onChange={(e) => {
                        const selectedId = e.target.value; // Keep it as a string
  
                        // Update React-Hook-Form state (as a number)
                        methods.setValue("countyId", Number(selectedId));
  
                        // Update local state (as a string)
                        setHospitalData((prev) => ({
                          ...prev,
                          countyId: selectedId, // Stay as string to match state
                        }));
                      }}
                      disabled
                    >
                      <option value={0}>Select County</option>
                      {counties.map((cnt) => (
                        <option key={cnt.id} value={Number(cnt.id)}>
                          {cnt.value}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.countyId && (
                      <p className="text-danger mb-0">
                        {errors.countyId.message}
                      </p>
                    )}
                  </Col>
                </Row>

                <Row className="mb-4">
                  <Col>
                    <AppLabel label="Zip Code" required />
                    <Form.Control
                      type="text"
                      {...methods.register("hospitalZipCode")}
                      maxLength={5}
                      disabled
                    />
                    {errors.hospitalZipCode && (
                      <p className="text-danger mb-0">
                        {errors.hospitalZipCode.message}
                      </p>
                    )}
                  </Col>
                  <Col></Col>
                  <Col></Col>
                </Row>

              </AppCard>

              {/* This will be save in Lu.RoutnizedFacility */}

              <AppCard title="Location" bottomMargin >

                <AppDataTable
                  columns={LocationTableColumn} //Facility
                  data={setFacilities}
                ></AppDataTable>
                <div className="row mt-2">
                  <div className="modal-button">
                    <button
                      className="modal-button"
                      onClick={() => {
                        setModalShow(true);
                        setSelectedRow(undefined);
                      }}
                      //disabled={formDisabled}
                      name=""
                     disabled={!fieldsEnabled}
                    >
                      + Add New
                    </button>
                    {/* <ProviderModal
                        isOpen={modalPopup}
                        onClose={() => {
                          handleClose();
                          setEditProvider({} as ProviderModalData);
                        }}
                        onSelection={handleProviderData}
                        editProviderData={editProvider}
                      ></ProviderModal> */}
                  </div>
                </div>
              </AppCard>

              <AppCard title="Users" bottomMargin >

                <AppDataTable
                  columns={UserColumn} //Facility
                  data={userData}
                ></AppDataTable>
                <div className="row mt-2">
                  <div className="modal-button">
                    <button
                      className="modal-button"
                      onClick={() => {
                        setUserModalShow(true);
                        setUserSelectedRow(undefined);
                      }}
                      //disabled={formDisabled}
                      name=""
                     disabled={!fieldsEnabled}
                    >
                      + Add New
                    </button>
                    {/* <ProviderModal
                        isOpen={modalPopup}
                        onClose={() => {
                          handleClose();
                          setEditProvider({} as ProviderModalData);
                        }}
                        onSelection={handleProviderData}
                        editProviderData={editProvider}
                      ></ProviderModal> */}
                  </div>
                </div>
              </AppCard>

              
              
              


              {/* Save Button */}
               <div className="text-end mb-">
               
                  {/* <AppButton variant="primary" type="submit">
                    Save
                  </AppButton> */}
                  <NavLink to={"/Facility/Dashboard"}>
                  <AppButton variant="secondary" >
                    Cancel
                  </AppButton>
                  </NavLink>
               
              </div> 

              {isRejectModalOpen && (
                <AppModal
                  title={"Reason for rejection"}
                  show={isRejectModalOpen}
                  primaryButtonText="Reject"
                  onPrimaryClicked={() => {
                    handleRejectSubmit();
                  }}
                  onSecondaryClicked={handleModalClose}
                  onHide={handleModalClose}
                >
                  <div>
                    {/* <label htmlFor="rejectComment">Reason for rejection</label> */}
                    <textarea
                      id="rejectComment"
                      value={rejectComment}
                      onChange={(e) => setRejectComment(e.target.value)}
                      placeholder="Enter reason for rejection"
                      rows={4}
                      style={{ width: "100%", margin: "10px 0" }}
                      maxLength={1500}
                    />

                  </div>
                </AppModal>
              )}
            </AppCard>
          </Form>
        </FormProvider>
        
      </Container>
      <LocationModal show={isModalShow} data={selectedRow} onHide={function (): void {
          setModalShow(false); setSelectedRow(undefined)
        }} onSave={handleModalSubmit}></LocationModal>


      <UserModal show={isUserModalShow} hospitalId={hospitalId} data={selectedUserRow} onHide={function (): void {
          setUserModalShow(false); setSelectedRow(undefined)
        }} onSave={handleCreateUserSubmit}></UserModal>

       
    </>
  );

};

export default FacilityEdit
